import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import './PaymentMethodsForm.css';

// Editor de defaults org-level de métodos de pago (NER-1285, item 5 / OWNER).
// SÓLO campos heredables: flags `enabled` (todos) + datos bancarios del transfer
// (bank/cbu/alias). Las credenciales NUNCA se configuran acá — son per-sucursal
// y viven en el override del restaurante. Espejo de INHERITABLE_FIELDS del backend.
// El backend (PUT /organizations/{id} con `paymentMethodDefaults`) rechaza (400)
// cualquier campo de credencial.

const METHOD_META = [
  { key: 'cash', icon: 'payments', labelKey: 'payment.cash' },
  { key: 'card', icon: 'credit_card', labelKey: 'payment.card' },
  { key: 'transfer', icon: 'account_balance', labelKey: 'payment.transfer' },
  { key: 'mercadoPago', icon: 'qr_code_2', labelKey: 'payment.mercadopago' },
  { key: 'lineCheckout', icon: 'smartphone', labelKey: 'payment.lineCheckout' },
];

const OrgPaymentDefaultsForm = ({ value, onChange }) => {
  const { t } = useTranslation();
  const defaults = value && typeof value === 'object' ? value : {};

  const cfg = (method) => defaults[method] || {};

  const setField = (method, field, fieldValue) => {
    onChange({
      ...defaults,
      [method]: { ...cfg(method), [field]: fieldValue },
    });
  };

  const toggle = (method) => setField(method, 'enabled', !cfg(method).enabled);

  return (
    <div className="payment-methods-form">
      <p className="payment-inherit-hint">
        <Icon name="info" size="small" />
        {t('settings.orgPaymentDefaults.credentialsNote')}
      </p>

      {METHOD_META.map(({ key, icon, labelKey }) => {
        const enabled = !!cfg(key).enabled;
        return (
          <div key={key} className="payment-method-card">
            <div className="method-header">
              <div className="method-title">
                <Icon name={icon} />
                <span>{t(labelKey)}</span>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={enabled}
                  aria-label={t(labelKey)}
                  onChange={() => toggle(key)}
                />
                <span className="slider round"></span>
              </label>
            </div>

            {key === 'transfer' && enabled && (
              <div className="method-details">
                <div className="form-group">
                  <label>{t('payment.bank')}</label>
                  <input
                    type="text"
                    value={cfg('transfer').bank || ''}
                    onChange={(e) => setField('transfer', 'bank', e.target.value)}
                    placeholder="Ej: Banco Galicia"
                  />
                </div>
                <div className="form-group">
                  <label>{t('payment.cbu')}</label>
                  <input
                    type="text"
                    value={cfg('transfer').cbu || ''}
                    onChange={(e) => setField('transfer', 'cbu', e.target.value)}
                    placeholder="0000000000000000000000"
                  />
                </div>
                <div className="form-group">
                  <label>{t('payment.alias')}</label>
                  <input
                    type="text"
                    value={cfg('transfer').alias || ''}
                    onChange={(e) => setField('transfer', 'alias', e.target.value)}
                    placeholder="Ej: MI.ALIAS.MP"
                  />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OrgPaymentDefaultsForm;
